import { Card } from 'sections/Benefits/types';

export const cards: Card[] = [
  {
    id: 1,
    icon: 'icon-logistics-explorer.svg',
    title: 'Logistics Explorer',
    description: 'Use our real-time freight calculator. Quote your rates to thousands of customers at any time and get online bookings for FCL, LCL, Air, Road, Rail transport, and more.',
    link: '/digital-tools/logistics-explorer',
    alt: 'Logistics Explorer',
  },
  {
    id: 2,
    icon: 'icon-tracking-system.svg',
    title: 'Tracking System',
    description: 'Track your cargo by container number, bill of lading (BOL), or booking. This tool collects all the necessary information to give you full visibility and up-to-date statistics for your shipments.',
    link: '/digital-tools/tracking-system',
    alt: 'Tracking System',
  },
  {
    id: 3,
    icon: 'icon-ship-schedules.svg',
    title: 'Ship Schedules',
    description: 'Our tool shows the current shipping schedules by routing, by port, by vessel, or by the carrier. Plan container bookings or analyze vessel movements and transit time.',
    link: '/digital-tools/ship-schedules',
    alt: 'Ship Schedules',
  },
];